import { addHeaderToArray } from "../../addHeaderToArray";
import { addAOChartToGridElements } from "./addAOChartToGridElements";
import { addAOCreatorsToGridElements } from "./addAOCreatorsToGridElements";
import { addAOPlatformToGridElements } from "./addAOPlatformToGridElements";

export const addAudienceOverlapToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.audienceOverlap;

  Object.keys(campaigns).forEach((campaignId) => {
    const {
      audienceOverlap,
      project: { title },
    } = campaigns[campaignId];

    if (!audienceOverlap) return;
    const { audienceOverlapData } = audienceOverlap;

    if (campaignId !== "aggregated") {
      const visible = !aggregation && Object.keys(campaigns).length > 1;

      addHeaderToArray(
        title,
        visible ? newGridElements : newHiddenGridElements,
        3,
        `audience-overlap-${campaignId}`,
        savedTemplate,
        templateApplied,
        "audience-overlap",
      );
    }

    const overlapProviders = Object.keys(audienceOverlapData || {});

    overlapProviders.forEach((provider) => {
      const overlapData = audienceOverlapData[provider];

      if (!overlapData?.audienceOverlap?.data) return;

      addAOPlatformToGridElements(
        newGridElements,
        newHiddenGridElements,
        savedTemplate,
        templateApplied,
        aggregation,
        campaignId,
        provider,
      );

      addAOChartToGridElements(
        newGridElements,
        newHiddenGridElements,
        savedTemplate,
        templateApplied,
        aggregation,
        campaignId,
        provider,
        overlapData,
      );

      addAOCreatorsToGridElements(
        newGridElements,
        newHiddenGridElements,
        savedTemplate,
        templateApplied,
        aggregation,
        campaignId,
        provider,
        overlapData,
      );
    });
  });
};
